<div class="confirmed-error-content">
  <div class="icon-container"><i class="oda-remove-circle"></i></div>

  <h3 class="error-title heading-11">{{"queue.confirm.failed.title.1" | translate}}</h3>
  <p class="error-desc heading-9">{{"queue.confirm.failed.desc.1" | translate}}</p>

  <button class="retry-button" (click)="onClickRetry()">{{"button.retry" | translate}}</button>
</div>
